export default "__VITE_ASSET__wcWNmSba__"